module.exports = __webpack_public_path__ + "img/dizzy-robot.ea1736d0.svg";